import axios from "axios";
import { getSessionToken } from "../../utils/Auth/AuthUtils";
//import { useSelector } from "react-redux";
const API_URL = "/api/student";

//Create new student
const addStudent = async (studentData) => {
  const token = await getSessionToken();

  const config = {
    headers: {
      "Content-Type": "application/json",
      Authorization: token,
    },
  };
  const response = await axios.post(API_URL + "/create", studentData, config);
  return response.data;
};

// Get students
const getStudents = async () => {
  const token = await getSessionToken();
  const config = {
    headers: {
      "Content-Type": "application/json",
      Authorization: token,
    },
  };
  const response = await axios.get(API_URL + "/all", config, {});
  return response.data;
};

//Edit student
const editStudent = async (studentData) => {
  const token = await getSessionToken();
  const response = await axios({
    method: "post",
    url: API_URL + "/update",
    headers: {
      "Content-Type": "application/json",
      Authorization: token,
    },
    data: studentData,
  });

  return response.data;
};

// Get students
const getStudent = async (student_id) => {
  const token = await getSessionToken();
  const response = await axios({
    method: "get",
    url: API_URL,
    headers: {
      "Content-Type": "application/json",
      Authorization: token,
    },
    params: {
      student_id: student_id,
    },
    timeout: 4000,
  });
  return response.data;
};

// Delete user student
const deleteStudent = async (studentId) => {
  const token = await getSessionToken();
  const response = await axios.delete(API_URL, {
    headers: {
      "Content-Type": "application/json",
      Authorization: token,
    },
    data: {
      student_id: studentId
    },
  });
  return response.data;
};

const studentService = {
  addStudent,
  editStudent,
  getStudent,
  getStudents,
  deleteStudent,
};

export default studentService;
